import { AnswerSelectContainerProps } from '../config';
import { CountryKey } from '../../../../utils/wpo/codes';
import { FC, useEffect } from 'react';
import { IAnswerModel } from '../../../../state/stores/Question/AnswerModel';
import { SnapshotOrInstance, SnapshotOut } from 'mobx-state-tree';
import { countryFlags } from '../../../../utils/wpo/flags';
import { getMetaValue } from '../../utils';
import { observer } from 'mobx-react';
import { useInitChoiceWithFirstAnswer } from '../useInitChoiceWithFirstAnswer';
import { useStores } from '../../../../hooks/useStores';


const flagAndName = (country: CountryKey, labels: Record<string, string>) => {
  return countryFlags[country] + '   ' + labels[country?.toUpperCase()];
};

const _ContainRegion : FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
}) => {
  const { user, language } = useStores();
  const labels = language?.translate.MOBILE?.ASSISTANCE?.INSTANT_HELP;
  const answers: SnapshotOut<IAnswerModel>[] = question.answers
    ?.map(answer => {
      if (answer.key === 'fail') {
        return answer;
      }
      const countryKey = getMetaValue('countryKey2', answer);
      return {
        ...answer,
        wording: flagAndName(countryKey as CountryKey, labels?.REGIONS),
      };
    }) || [];

  const [initAnswer] = useInitChoiceWithFirstAnswer({
    answers,
    questionId: question._id,
    questionKey: question.key,
    findInitialChoice: answer => user.user?.region === null || user.user?.region === undefined || getMetaValue('countryKey2', answer) === user.user?.region,
  });
  const initAnswerCountryKey = getMetaValue('countryKey2', initAnswer);

  // automatically initialised answer also sets user region
  useEffect(() => {
    if (initAnswerCountryKey) {
      console.log(`ContainRegion.useEffect user.setRegion(${initAnswerCountryKey})`);
      user.setRegion(initAnswerCountryKey as CountryKey);
    }
  }, [initAnswerCountryKey, user]);

  const onPressIdiosyncratic = (answer: SnapshotOrInstance<IAnswerModel>) => {
    if(answer.key !== 'fail') {
      const countryKey = getMetaValue('countryKey2', answer);
      console.log(`ContainRegion.onPressIdiosyncratic user.setRegion(${countryKey})`);
      user.setRegion(countryKey as CountryKey);
    }
    onPress(answer);
  };

  return children({
    answers: answers,
    initSelected: initAnswer,
    questionId: question._id,
    questionKey: question.key,
    onPress: onPressIdiosyncratic,
    labels: {
      DROPDOWN: labels?.REGION,
    }
  });

};

export const ContainRegion = observer(_ContainRegion);

